import { Component, ContentChild, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { NudgeService } from '../../services/nudge.service';
import { InfraNudgeComponent } from 'src/app/collection-infrastructure/nudges/infra-nudge/infra-nudge.component';

@Component({
  selector: 'app-common-nudge',
  templateUrl: './common-nudge.component.html',
  styleUrls: ['./common-nudge.component.css']
})
export class CommonNudgeComponent implements OnInit, OnDestroy {
  @Input() position: string = 'bottom-right';
  @Input() nudgeId: string;
  @Input() dismissDuration: number = 1800000; // duration in milliseconds
  showNudge: boolean;
  nudgeVisibilitySubscription: Subscription;
  @ContentChild(InfraNudgeComponent, { static: false }) infraNudgeComponent: InfraNudgeComponent;

  constructor(private _nudgeService: NudgeService) { }

  ngAfterContentInit() {
    if (this.infraNudgeComponent) {
      this.infraNudgeComponent.dismissNudge.subscribe(() => this.dismissNudge());
    }
  }

  ngOnInit() {
    this.showNudge = this._nudgeService.isNudgeVisible(this.nudgeId);
    this.nudgeVisibilitySubscription = this._nudgeService
    .getNudgeVisibilitySubject(this.nudgeId)
    .subscribe(visible => {
      this.showNudge = visible;
    });
  }

  ngOnDestroy() {
    if (this.nudgeVisibilitySubscription) {
      this.nudgeVisibilitySubscription.unsubscribe();
    }
  }

  dismissNudge(){
    this.showNudge = false;
    this._nudgeService.dismissNudge(this.nudgeId, this.dismissDuration);
  }
}
